/* Original Renegade v40 — lightweight form guards and outcome focus. */
(function(){
'use strict';
function guard(form,selector){if(!form)return;form.addEventListener('submit',function(event){var trap=form.querySelector(selector);if(trap&&trap.value!=='')event.preventDefault()})}
function focusOutcome(){var target=document.querySelector('.or-contact__success,.or-feedback__success,.or-contact__errors,.or-feedback__errors');if(!target)return;if(!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');window.requestAnimationFrame(function(){try{target.focus({preventScroll:true})}catch(error){target.focus()}})}
guard(document.getElementById('ContactForm'),'.contact-trap input');
guard(document.getElementById('ORFeedbackForm'),'.or-feedback__trap input');
focusOutcome();
})();
